var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-page"},[_c('BannerComponent'),_c('div',{staticClass:"content-section"},[_c('IntroductionComponent'),_c('CyapssApplicationsComponent'),_c('CyapssTestimonialsComponent'),_c('MoreInformation')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }